import React from "react";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInstagram, faLinkedin} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <Link to="/terms-and-conditions">Terms & Conditions</Link>

        <span className="footer-copyright">
          Copyright © 2023-2026 Yekkada.com
          <span className="footer-copyright-full"> powered by Satyology Solutions Private Limited</span>
        </span>

        <div className="footer-links">
          {/* Follow-us social links — open the official Yekkada profiles in a new tab. */}
          <a
            href="https://www.instagram.com/Yekkada_get_tracking"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social"
            aria-label="Yekkada on Instagram"
            title="Follow us on Instagram"
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a
            href="https://www.linkedin.com/showcase/yekkada-fleet-tracking/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social"
            aria-label="Yekkada on LinkedIn"
            title="Follow us on LinkedIn"
          >
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
